/**
 * Using for recomendation products and recent view products
 */
if (!customElements.get('size-guide-table')) {
  customElements.define(
    'size-guide-table',
    class SizeGuideTable extends HTMLElement {
      constructor() {
        super();
        this.tableCM = this.querySelector('[data-size-guide-table-cm]');
        this.tableInch = this.querySelector('[data-size-guide-table-inch]');
        this.sizeGuideTable = this.querySelector('[data-size-guide-table]');
        this.init()
      }

      init() {
        if (this.tableCM && this.tableInch && this.sizeGuideTable) {
          this.tableCM.classList.add('active');
          this.tableCM.classList.remove('hidden');
          this.tableInch.classList.remove('hidden');
          this.sizeGuideTable.prepend(this.tableInch);
          this.sizeGuideTable.prepend(this.tableCM);
          const tables = this.querySelectorAll('[data-size-guide-table] table');
          const switchItems = this.querySelectorAll('[data-switch-item]');
          switchItems.forEach((swatch, index) => {
            swatch.addEventListener('click', (event) => {
              switchItems.forEach((table, switchIndex) => {
                table.classList.toggle('active', index === switchIndex);
              });
              tables.forEach((table, tableIndex) => {
                table.classList.toggle('active', index === tableIndex);
              });
            });
          });
        }
      }
    }
  );
}
